<template>
  <b-container class="mb-4">
    <h1 class="title text-center">{{ pageTitle }}</h1>

    <div
      v-if="isLoading"
      class="loader"
    >
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <b-row v-if="!isLoading" class="justify-content-center mt-4">
      <b-col lg="5" md="5" sm="12" class="deal-cover">
        <h5>Deal Info</h5>

        <b-img-lazy
          blank="true"
          :blank-src="require('../assets/images/eclipse.gif')"
          :src="deal.attributes.image_url"
          alt="Cover"
        ></b-img-lazy>

        <div class="p-3 font-lighter">
          <p style="font-size: 20px;">{{ deal.attributes.name }}</p>
          <p class="text-secondary mb-0">{{ deal.attributes.description }}</p>
          <div class="cut-line">
            <ins>
              <span>Price: ${{ deal.attributes.deal_price }}</span>
            </ins>

            <del class="float-right">
              <span>$ {{ deal.attributes.price }}</span>
            </del>
          </div>
          <p v-if="deal.attributes.limited_time_offer">Time: {{ deal.attributes.offer_start_time | moment("h:mm A") }} - {{ deal.attributes.offer_end_time | moment("h:mm A") }}</p>
          <b-button squared @click="showModal" variant="outline-primary" class="w-100">Add to Cart</b-button>
        </div>
      </b-col>

      <b-col lg="7" md="7" sm="12">
        <b-row >
          <b-col cols="3">
            <h5>Item</h5>
          </b-col>

          <b-col cols="9">
            <h5>Detail</h5>
          </b-col>
        </b-row>

        <b-row
          v-for="deal_item in deal.attributes.deal_items.data"
          :key="deal_item.id"
          class="border-top py-3"
        >
          <b-col cols="3" class="img-size">
            <b-img-lazy
              blank='true'
              :blank-src="require('../assets/images/eclipse.gif')"
              :src="deal_item.attributes.image_url"
              alt="Deal Item Image"
            ></b-img-lazy>
          </b-col>

          <b-col cols="9" class="font-lighter border-left">
            <p class="mb-1" style="font-size: 20px;">{{ deal_item.attributes.name }}</p>
            <p class="mb-0" v-if="deal_item.attributes.description != '...' && deal_item.attributes.description != ''">{{ deal_item.attributes.description }}</p>
            <p class="mb-0">Price: ${{ deal_item.attributes.price }}</p>
          </b-col>
        </b-row>
      </b-col>

      <deal-item-modal
        :menu_items="deal.attributes.deal_items.data"
        :dea_id="deal.id"
      >
      </deal-item-modal>
    </b-row>
  </b-container>
</template>

<script>
import { getDeal } from '../store/api'
import DealItemModal from "../components/DealItemModal";

export default {
  name: 'deal-show',

  components: {
    'deal-item-modal': DealItemModal,
  },

  data() {
    return {
      pageTitle: 'Deal Details',
      deal: {},
      isLoading: true,
    }
  },

  created() {
    getDeal(this.$route.params.id)
      .then(response => {
        this.deal = response.data
        this.pageTitle = response.data.attributes.name
        this.isLoading = false
      })
  },

  methods: {
    showModal() {
      this.$root.$emit('bv::show::modal', 'selected_menu_item')
    },
  }
}
</script>

<style scoped>
  .card-subtitle {
    color: white !important;
  }
  .deal-cover img {
    width: 100%;
    height: 250px;
  }
  .img-size img{
    width: 100%;
    height: 120px;
    object-fit: fill;
  }
  .cut-line del {
    color: #707070;
    text-decoration: none;
    position: relative;
    font-size: 17px;
    font-weight: 100;
  }
  .cut-line del:after {
    content: "";
    display: block;
    width: 100%;
    border-top: 1px solid #707070;
    height: 4px;
    position: absolute;
    bottom: 10px;
    left: 0;
  }
  .cut-line ins {
    text-decoration: none;
  }
  .btn-outline-primary {
    color: #5663FF;
    border-color: #5663FF;
    background-color: white;
    box-shadow: none;
  }
  .btn-outline-primary:hover {
    color: white;
    border-color: #5663FF;
    background-color: #5663FF;
  }
</style>
